export default "__VITE_ASSET__05445d25__"